module.exports = __webpack_public_path__ + "static/media/gokei.25c0de56.JPG";